<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <div class="form-div">
    <form class="user-form">
      <p class="heading">What city are you currently based in?</p>
      <mat-form-field 
        appearance="fill" 
        class="full-width rounded-input black-caret"
        [class.valid-input]="locationControl.valid && selectedLocation"
        [class.invalid-input]="locationControl.invalid && locationControl.touched && availableOptions.length === 0"
        [class.has-suggestions]="availableOptions.length > 0"
      >
        <input
          type="text"
          matInput
          [formControl]="locationControl"
          [matAutocomplete]="auto"
          required
        />
        <mat-autocomplete #auto="matAutocomplete" class="separated-dropdown-options" (optionSelected)="onLocationSelected($event)">
          @for (option of filteredLocations | async; track $index) {
            <mat-option [value]="option">
              {{ option.description || option }}
            </mat-option>
          }
        </mat-autocomplete>

        @if (locationControl.hasError('required') && (
          locationControl.touched || locationControl.dirty)
        ) {
          <mat-error class="input-error">
            Location is required
          </mat-error>
        }

        @if (locationControl.hasError('invalidLocation') && locationControl.touched) {
          <mat-error class="input-error">
            Enter a valid city
          </mat-error>
        }
      </mat-form-field>

      <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
    </form> 
  </div>
</div>